/**
 * @generated SignedSource<<409d81f44eda51c208a91e788b58eb2f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateClickOutForUserOrBusinessInput = {
  clientMutationId?: string | null;
};
export type placement_ClickoutMutation$variables = {
  input: CreateClickOutForUserOrBusinessInput;
};
export type placement_ClickoutMutation$data = {
  readonly Placement: {
    readonly createClickOutForUserOrBusiness: {
      readonly placementUrl: string;
    } | null;
  };
};
export type placement_ClickoutMutation = {
  response: placement_ClickoutMutation$data;
  variables: placement_ClickoutMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PlacementMutations",
    "kind": "LinkedField",
    "name": "Placement",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "CreateClickOutForUserOrBusinessPayload",
        "kind": "LinkedField",
        "name": "createClickOutForUserOrBusiness",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "placementUrl",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "placement_ClickoutMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "placement_ClickoutMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d6c491ddc522e346cb716988bc073efa",
    "id": null,
    "metadata": {},
    "name": "placement_ClickoutMutation",
    "operationKind": "mutation",
    "text": "mutation placement_ClickoutMutation(\n  $input: CreateClickOutForUserOrBusinessInput!\n) {\n  Placement {\n    createClickOutForUserOrBusiness(input: $input) {\n      placementUrl\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "03d764af862256db78bf2471fbaf1bf7";

export default node;
